import { Icon16ChainOutline, Icon16MailOutline, Icon16PenOutline } from '@vkontakte/icons';
import { ReactComponent as ShareIcon } from 'img/icons/editor/r7ShareIcon.svg';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { getDomainRestrictionsForItems } from 'reactApp/appHelpers/appHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { newEditorToolsEnabled } from 'reactApp/appHelpers/featuresHelpers/features/editorToolsFakedoor';
import { renderNewComfirmationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import type { EditorItem } from 'reactApp/modules/editor/editor.types';
import { isOwnPublic } from 'reactApp/modules/public/public.selectors';
import { EditorToolButton } from 'reactApp/ui/EditorHeader/BizInlineEditorToolbar/components/EditorToolButton/EditorToolButton';

interface EditorToolsProps {
    handlePublish: (e: React.MouseEvent<HTMLButtonElement>) => void;
    file: EditorItem | null;
    isReady: boolean;
    isPublic: boolean;
}

export const EditorTools = memo(({ file, isReady, handlePublish, isPublic }: EditorToolsProps) => {
    const { isDomainAndShareRestricted } = getDomainRestrictionsForItems(file);
    const showPublish = !isDomainAndShareRestricted;
    const isPublicOwner = useSelector(isOwnPublic);
    const showTools = (isPublic && isPublicOwner) || !isPublic;

    const onFakeDoorClick = (type: 'rename' | 'send') => {
        switch (type) {
            case 'rename':
                emitAnalyticEvent(AnalyticEventNames.EDITOR_TOOLS_RENAME_CLICK);
                break;
            case 'send':
                emitAnalyticEvent(AnalyticEventNames.EDITOR_TOOLS_SEND_ATTACH_CLICK);
                break;
        }

        renderNewComfirmationDialog({
            dataQAId: 'editor-tools-fakedoor-dialog',
            renderHeader: () => 'Спасибо за интерес',
            buttons: [EButtonType.accept],
            successButtonText: 'Понятно',
            renderContent: () => 'Этот функционал сейчас в разработке',
            closeOnDimmerClick: true,
        });
    };

    if (!isReady) {
        return null;
    }

    if (newEditorToolsEnabled) {
        return (
            <>
                {showTools && (
                    <>
                        <EditorToolButton
                            icon={<Icon16PenOutline />}
                            onClick={() => onFakeDoorClick('rename')}
                            testId="rename-button"
                            tooltipText="Переименовать"
                        />
                        <EditorToolButton
                            icon={<Icon16MailOutline />}
                            onClick={() => onFakeDoorClick('send')}
                            testId="send-attach-button"
                            tooltipText="Отправить по почте"
                        />
                    </>
                )}
                {showPublish && (
                    <EditorToolButton
                        icon={<Icon16ChainOutline />}
                        onClick={handlePublish}
                        testId="share-button"
                        tooltipText="Поделиться"
                    />
                )}
            </>
        );
    }

    if (showPublish) {
        return <EditorToolButton testId="share-button" onClick={handlePublish} text="Поделиться" icon={<ShareIcon />} />;
    }

    return null;
});

EditorTools.displayName = 'EditorTools';
